import ApiCore from "./api_core"
import { NewUserI, UpdatedUserI, UserFiltersI, UserActivationI, UserI, UserRoleName } from "./types"

export default new class {
    all(params={} as UserFiltersI) {
        return ApiCore.getJson<UserI[]>('users', params)
    }

    get(id: number){ 
        return ApiCore.getJson<UserI>(`users/${id}`)
    }

    create(user: NewUserI) {
        return ApiCore.postJson<UserI>('users', user)
    }

    update(id: number, user: UpdatedUserI) {
        return ApiCore.putJson<UserI>(`users/${id}`, user)
    }

    activate(id: number) {
        return ApiCore.postJson<UserActivationI>(`users/${id}/activate`, {})
    }

    deactivate(id: number) {
        return ApiCore.postJson<UserActivationI>(`users/${id}/deactivate`, {})
    }
}
